import { BeachVolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const SetBallPopup = new PopupBuilder('Set ball', {
  incident_id: BeachVolleyballIncidentId.SetBall,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
